RivalIQ.module('apps', function (apps, App, Backbone, Marionette, $, _, history) {

    'use strict';

    const name = 'Dashboard';

    const app = apps[name] = window.createMarionetteApp();

    app.name = name;

    app.addRegions({
        widgetsRegion: {
            selector: '#widgets-region',
            regionClass: Marionette.Dashboard.views.LoadingRegion
        },
        toolbar: '#toolbar-region',
        titlebar: '#titlebar-region'
    });

    app.on('start', function () {
        // NOTE we need to support browsers that have not implemented push
        // state (*cough* IE9 *cough*), and to do so requires special
        // parameters to be specified during the start of Backbone.history:
        // root, as '/', so that the paths look the same, and hashChange, as
        // false, so that the browser goes back to the server rather than
        // running on the existing router
        const historyOptions = (history.pushState ?
            {
                pushState: true
            } :
            {
                root: '/',
                hashChange: false
            });

        Backbone.history.start(historyOptions);

        const location = window.location.pathname + window.location.hash;
        apps[name].legacyRouteHandler.checkForLegacyRoutes(location);
    });

    Marionette.Region.prototype.showWidget = function (widget, attrs, options) {
        const me = this;
        const View = widget.getView();

        return me.show(new View(_.extend(attrs || {}, {
            dashboardModel: widget
        })), options || {});
    };

}, window.history);
